import { PlansTab } from "../../plans/UniversalPlansBox";

const WalletApiPlansTab = () => {
  const walletApiServiceType =
    Number(import.meta.env.VITE_WALLET_API_SERVICE_TYPE) || 7;

  return (
    <>
      <PlansTab serviceType={walletApiServiceType} />
    </>
  );
};

export default WalletApiPlansTab;
